/*
 *
 * Copyright (c) 1999-2021 Luciad All Rights Reserved.
 *
 * Luciad grants you ("Licensee") a non-exclusive, royalty free, license to use,
 * modify and redistribute this software in source and binary code form,
 * provided that i) this copyright notice and license appear on all copies of
 * the software; and ii) Licensee does not utilize the software in a manner
 * which is disparaging to Luciad.
 *
 * This software is provided "AS IS," without a warranty of any kind. ALL
 * EXPRESS OR IMPLIED CONDITIONS, REPRESENTATIONS AND WARRANTIES, INCLUDING ANY
 * IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
 * NON-INFRINGEMENT, ARE HEREBY EXCLUDED. LUCIAD AND ITS LICENSORS SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING
 * OR DISTRIBUTING THE SOFTWARE OR ITS DERIVATIVES. IN NO EVENT WILL LUCIAD OR ITS
 * LICENSORS BE LIABLE FOR ANY LOST REVENUE, PROFIT OR DATA, OR FOR DIRECT,
 * INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES, HOWEVER
 * CAUSED AND REGARDLESS OF THE THEORY OF LIABILITY, ARISING OUT OF THE USE OF
 * OR INABILITY TO USE SOFTWARE, EVEN IF LUCIAD HAS BEEN ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGES.
 */
var errorTags = {};
var warningTags = {};

export var toast = {
  toast: function(className, message) {
    var toasts = document.getElementById("toasts");
    var toast = document.createElement("div");
    toast.className = "toast " + className;
    toast.innerHTML = message;
    toast.style.opacity = 1;
    toasts.appendChild(toast);

    setTimeout(function() {
      toast.style.opacity = 0;
      var hideToast = function() {
        toast.style.display = "none";
      };
      toast.addEventListener("transitionend", hideToast, false);
      toast.addEventListener("webkitTransitionEnd", hideToast, false);
    }, 12000);
  },

  info: function(message) {
    console.log(message);
    this.toast("", message);
  },

  error: function(tag, message, error) {
    if (tag && tag in errorTags) {
      //already logged errors for tag
      return;
    }
    errorTags[tag] = true;
    console.error((error && error.message) || error || message);
    this.toast("error", message);
  },

  warn: function(tag, message, error) {
    if (tag && tag in warningTags) {
      //already logged warnings for tag
      return;
    }
    warningTags[tag] = true;
    console.warn((error && error.message) || error || message);
    this.toast("warning", message);
  }
};
